export class EoModel {
  id: number;
  FLEET: string;
  EPRS_NBR: string;
  EPRS_DATE: Date;
  EPRA_NBR: string;
  EPRA_DATE: Date;
  EO_NBR: string;
  EO_RELEASE_DATE: Date;
  DESCRIPTION: string;
  JUSTIFICATION: string;
  EO_TYPE: string;
  ANALYZE_IND: number;
  PLANNED_ANALYSIS_DATE: Date;
  ON_SCHEDULE_IND: number;
  VP_BRIEF_DATE: Date;
  VP_BRIEF_IND: number;
  FT_BRIEF_DATE: Date;
  FT_BRIEF_IND: number;
  PRIMARY_ATA: string;
  REPETITIVE_IND: number;
  PERCENT_ACCOMPLISHED: number;
  COMMENTS: string;
  DATE_OF_LAST_ANALYSIS: Date;
  ONE_NOTE_LINK: string;
  ENTERED_BY: string;
  ENTERED_AT: Date;
  UPDATED_BY: string;
  UPDATED_AT: Date;
  OPTIX_OBJ_ID: number;
  FORECASTED_NEXT_CHECKPOINT_DATE: Date;
  ATTACHMENTS: string;
  NEXT_ALERT_PERCENT_THRESHOLD: number;
}
